import ObjCommon from './ObjCommon';
import { baseUrlGet } from '../common';

class PhotoSer extends ObjCommon {

  slug = '';
  name = '';
  desc = '';
  group = '';
  represent = {};
  sType = '';
  sOrd = 0;
  fold = '';
  photos = [];

  constructor(id) {
    super(id);
  } 

  imPGet(ph) {
    const urlBase = baseUrlGet();
    const imP = urlBase + '/stat-u/photo-series/' + this.fold + '/' + ph;  
    return imP;
  }


}

export default PhotoSer;
